import React from 'react';
import Overlay from '../../partials/white_overlay';

const Coaches = () => {
    return (
        <div style={{ position: 'relative' }}>
            <Overlay />
            <div className="p-4 hind" style={{ mixBlendMode: 'screen' }}>
                <h2 className="hind">Coaches</h2>
                <p>Three (3) is the maximum number of coaches that can accompany a team on the sideline during a match. Coaches may not cross beyond the midline and shall remain in close proximity to the team’s sideline area. Coaches must be on the roster and have a signed waiver.</p>
            </div>
        </div>
    );
}

export default Coaches;



// WEBPACK FOOTER //
// ./src/components/rules/partials/coaches.js